(() => {
  if (!document.querySelector('select.facet-filters__sort')) return;
  if (window.__ocDesktopSortV2) return;
  window.__ocDesktopSortV2 = true;

  const desktopMq = window.matchMedia('(min-width: 750px)');

  const labelFor = (option) => {
    if (!option) return 'SORT BY';

    const value = (option.value || '').toLowerCase();
    const text = (option.textContent || '').trim().toLowerCase();

    if (value === 'manual' || text === 'featured') return 'SORT BY FEATURED';
    if (value === 'best-selling' || text.includes('best selling')) return 'SORT BY BEST SELLING';
    if (value === 'title-ascending' || text.includes('alphabetically, a-z') || text === 'a-z') return 'SORT BY A-Z';
    if (value === 'title-descending' || text.includes('alphabetically, z-a') || text === 'z-a') return 'SORT BY Z-A';
    if (value === 'price-ascending' || text.includes('price, low to high')) return 'SORT BY $ LOW TO HIGH';
    if (value === 'price-descending' || text.includes('price, high to low')) return 'SORT BY $ HIGH TO LOW';
    if (value === 'created-ascending' || text.includes('date, old to new') || text.includes('old to new')) return 'SORT BY OLD TO NEW';
    if (value === 'created-descending' || text.includes('date, new to old') || text.includes('new to old')) return 'SORT BY NEW TO OLD';
    if (value === 'relevance' || text.includes('relevance')) return 'SORT BY RELEVANCE';

    return `SORT BY ${(option.textContent || '').trim().replace(/,/g, '')}`.toUpperCase();
  };

  const closeOthers = (except) => {
    document.querySelectorAll('[data-oc-desktop-sort-picker][open]').forEach((details) => {
      if (details !== except) details.removeAttribute('open');
    });
  };

  const buildPicker = (select) => {
    if (!select || select.dataset.ocDesktopSortReady === 'true') return;
    if (!select.classList.contains('facet-filters__sort')) return;

    const host = select.closest('.select');
    if (!host) return;

    select.dataset.ocDesktopSortReady = 'true';
    select.classList.add('oc-desktop-sort-native');
    host.classList.add('oc-desktop-sort-host');

    const details = document.createElement('details');
    details.className = 'oc-desktop-sort-picker';
    details.dataset.ocDesktopSortPicker = '';

    const summary = document.createElement('summary');
    summary.setAttribute('aria-label', 'Sort products');
    const label = document.createElement('span');
    label.dataset.ocDesktopSortLabel = '';

    const options = Array.from(select.options);
    const selected = options.find((option) => option.value === select.value) || options[0];
    label.textContent = labelFor(selected);
    summary.appendChild(label);

    const menu = document.createElement('div');
    menu.className = 'oc-desktop-sort-options';
    menu.setAttribute('role', 'listbox');
    menu.setAttribute('aria-label', 'Sort by');

    options.forEach((nativeOption) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'oc-desktop-sort-option';
      button.dataset.ocDesktopSortValue = nativeOption.value;
      button.setAttribute('role', 'option');
      const active = nativeOption.value === select.value;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
      button.textContent = labelFor(nativeOption);
      menu.appendChild(button);
    });

    details.appendChild(summary);
    details.appendChild(menu);
    host.appendChild(details);

    details.addEventListener('toggle', () => {
      if (details.open) closeOthers(details);
    });

    menu.addEventListener('click', (event) => {
      const button = event.target.closest('[data-oc-desktop-sort-value]');
      if (!button) return;

      event.preventDefault();
      const value = button.dataset.ocDesktopSortValue || '';
      const nativeOption = options.find((option) => option.value === value);

      if (select.value === value) {
        details.removeAttribute('open');
        return;
      }

      select.value = value;
      label.textContent = labelFor(nativeOption);

      menu.querySelectorAll('[data-oc-desktop-sort-value]').forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      details.removeAttribute('open');
      select.dispatchEvent(new Event('input', { bubbles: true }));
    });

    select.addEventListener('input', () => {
      const current = Array.from(select.options).find((option) => option.value === select.value);
      if (current) label.textContent = labelFor(current);
    });
  };

  const init = (root = document) => {
    root.querySelectorAll?.('select.facet-filters__sort').forEach(buildPicker);
  };

  document.addEventListener('click', (event) => {
    const openPicker = document.querySelector('[data-oc-desktop-sort-picker][open]');
    if (openPicker && !openPicker.contains(event.target)) openPicker.removeAttribute('open');
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-oc-desktop-sort-picker][open]').forEach((details) => details.removeAttribute('open'));
  });

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches?.('select.facet-filters__sort')) buildPicker(node);
        init(node);
      });
    }
  });

  const start = () => {
    init(document);
    if (document.body) observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();

  desktopMq.addEventListener?.('change', () => init(document));
})();
